// Service worker registration — for Web Push, not for installing anything.
//
// The app is deliberately **not** installable as a PWA. Installing the till is what
// `StockFlowArka-Setup.exe` does (a real Windows application with its own local database, see
// pos/README.md), and a browser-installed shortcut to the cloud back office looked identical on the
// Start Menu while doing none of the same work — operators reached for the wrong one. The manifest
// therefore declares `display: "browser"` and there is no install prompt in the UI.
//
// The service worker stays: browser Web Push (VAPID) needs one to receive notifications while no
// tab is open. See PushNotificationService on the API side.

const SW_URL = '/service-worker.js';

/**
 * Registers the service worker. Production only: in development the CRA dev server serves
 * unhashed bundles, and a service worker in front of them causes stale-code confusion.
 */
export function registerServiceWorker() {
  if (process.env.NODE_ENV !== 'production') return;
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register(SW_URL).catch((err) => {
      console.warn('[pwa] Service worker registration failed:', err);
    });
  });
}
